/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useContext, useCallback } from 'react';
import { Switch } from '@headlessui/react';
import { useNavigate } from 'react-router-dom';
import SidebarLogo from '../assets/images/new-shoorah-logo.svg';
import {
  cleanLocalStorage,
  errorToast,
  getDeviceToken,
  getLocalStorageItem
} from '../utils/helper';
import Menu from './Menu';
import { Api } from '../api';
import dashboardIcon from '../assets/images/Dashboard.svg';
import PeapDashboard from '../assets/images/PeapDashboard.svg';
import B2BWellPoints from '../assets/images/B2BWellPoints.svg';
import SpecialistManagement from '../assets/images/SpecialistManagement.svg';
import subadminIcon from '../assets/images/SubAdmin.svg';
import userIcon from '../assets/images/Users.svg';
import expertIcon from '../assets/images/expert.svg';
import peapIcon from '../assets/images/peap.svg';
import activePeapIcon from '../assets/images/active-peap.svg';
import DarkPeapIcon from '../assets/images/dark-peap.svg';
import activeExpertIcon from '../assets/images/active-expert.svg';
import expertDark from '../assets/images/dark-expert.svg';
import approvalIcon from '../assets/images/verify.svg';
import notiIcon from '../assets/images/Notification.svg';
import cmsIcon from '../assets/images/CMS.svg';
import earningIcon from '../assets/images/Ea5rning.svg';
import reportIcon from '../assets/images/reportIcon.svg';
import bagIcon from '../assets/images/bagIcon.svg';
import keyIcon from '../assets/images/keyIcon.svg';
import companyDashboardIcon from '../assets/images/companyDashboardIcon.svg';
import contentIcon from '../assets/images/Contentmanagement.svg';
import crownIcon from '../assets/images/crown.svg';
import moonIcon from '../assets/images/moon.svg';
import darkMoonIcon from '../assets/images/dark-moon.svg';
import logOutIcon from '../assets/images/logout.svg';
import darkLogOutIcon from '../assets/images/dark-logout.svg';
import { SidebarContext } from '../context/SidebarContext';

import activeTestIcon from '../assets/images/test-active-icon.svg';
import darkTestIcon from '../assets/images/test-dark-icon.svg';
import TestIcon from '../assets/images/test-black-icon.svg';
import activeCrownIcon from '../assets/images/ActiveCrown.svg';
import darkCrownIcon from '../assets/images/DarkCrown.svg';
import activedashboardIcon from '../assets/images/ActiveDashboard.svg';
import activepeapdashboardIcon from '../assets/images/ActivePeapDashboard.svg';
import activeb2bwellpointsIcon from '../assets/images/ActiveB2bWellPoints.svg';
import activespecialistmanagerIcon from '../assets/images/ActiveSpecialistManager.svg';
import activesubadminIcon from '../assets/images/ActiveSubAdmin.svg';
import darksubadminIcon from '../assets/images/DarkSubAdmin.svg';
import activeuserIcon from '../assets/images/ActiveUsers.svg';
import darkuserIcon from '../assets/images/DarkUsers.svg';
import activeapprovalIcon from '../assets/images/ActiveVerify.svg';
import darkapprovalIcon from '../assets/images/DarkVerify.svg';
import activenotiIcon from '../assets/images/ActiveNotification.svg';
import darknotiIcon from '../assets/images/DarkNotification.svg';
import activecmsIcon from '../assets/images/ActiveCMS.svg';
import darkcmsIcon from '../assets/images/DarkCMS.svg';
import activeearningIcon from '../assets/images/ActiveEa5rning.svg';
import darkearningIcon from '../assets/images/DarkEa5rning.svg';
import activereportIcon from '../assets/images/ActivereportIcon.svg';
import darkreportIcon from '../assets/images/DarkreportIcon.svg';
import activebagIcon from '../assets/images/ActivebagIcon.svg';
import darkbagIcon from '../assets/images/DarkbagIcon.svg';
import teamChallenges from '../assets/images/teamChallenges.svg';
import activeTeamChallenges from '../assets/images/ActiveTeamChallenges.svg';
import darkTeamChallenges from '../assets/images/DarkTeamChallenges.svg';
import goal from '../assets/images/sidebar/goal.svg';
import activeGoal from '../assets/images/sidebar/active-goal.svg';
import darkGoal from '../assets/images/sidebar/dark-goal.svg';
import activekeyIcon from '../assets/images/ActivekeyIcon.svg';
import darkkeyIcon from '../assets/images/DarkkeyIcon.svg';
import activecontentIcon from '../assets/images/ActiveContentmanagement.svg';
import darkcontentIcon from '../assets/images/DarkContentmanagement.svg';
import { useLocation } from 'react-router-dom';
import { CompanyApi } from '../api/companyApi';
import selfAssessmentActive from '../assets/images/selfAssessmentActiveIcon.svg';
import selfAssessmentDark from '../assets/images/selfAssessmentDarkIcon.svg';
import selfAssessment from '../assets/images/selfAssessmentIcon.svg';

import testIconActive from '../assets/images/test-active-icon.svg';
import testIcon from '../assets/images/test-black-icon.svg';
import testIconDark from '../assets/images/test-dark-icon.svg';

import marketplaceIconActive from '../assets/images/sidebar/marketplace-active-icon.svg';
import marketplaceIcon from '../assets/images/sidebar/marketplace-icon.svg';
import marketplaceIconDark from '../assets/images/sidebar/marketplace-dark-icon.svg';

import instantSupportActive from '../assets/images/sidebar/active-instant-support.svg';
import instantSupport from '../assets/images/sidebar/instant-support-icon.svg';
import instantSupportDark from '../assets/images/sidebar/instant-supportdarkicon.svg';
//import adminDark from '../assets/images/sidebar/dark-admins.svg';
//import admin from '../assets/images/sidebar/admins.svg';import adminActive from '../assets/images/sidebar/active-admins.svg';
import adminActive from '../assets/images/sidebar/active-admins.svg';
import adminDark from '../assets/images/sidebar/dark-admins.svg';
import admin from '../assets/images/sidebar/admins.svg';
import approvalActive from '../assets/images/sidebar/active-approval.svg';
import approvalDark from '../assets/images/sidebar/dark-approval.svg';
import approval from '../assets/images/sidebar/approval.svg';
import b2bActive from '../assets/images/sidebar/active-b2b.svg';
import b2bDark from '../assets/images/sidebar/dark-b2b.svg';
import b2b from '../assets/images/sidebar/b2b.svg';
import cmsActive from '../assets/images/sidebar/active-cms.svg';
import cmsDark from '../assets/images/sidebar/dark-cms.svg';
import cms from '../assets/images/sidebar/cms.svg';
import configActive from '../assets/images/sidebar/active-config.svg';
import configDark from '../assets/images/sidebar/dark-config.svg';
import config from '../assets/images/sidebar/config.svg';
import feedbackActive from '../assets/images/sidebar/active-feedback.svg';
import feedbackDark from '../assets/images/sidebar/dark-feedback.svg';
import feedback from '../assets/images/sidebar/feedback.svg';
import partnersActive from '../assets/images/sidebar/active-partners.svg';
import partnersDark from '../assets/images/sidebar/dark-partners.svg';
import partners from '../assets/images/sidebar/partners.svg';
import pushNotificationActive from '../assets/images/sidebar/active-push-notification.svg';
import pushNotificationDark from '../assets/images/sidebar/dark-push-notification.svg';
import pushNotification from '../assets/images/sidebar/push-notification.svg';
import companyActive from '../assets/images/sidebar/active-company.svg';
import companyDark from '../assets/images/sidebar/dark-company.svg';
import company from '../assets/images/sidebar/company.svg';
import usersActive from '../assets/images/sidebar/active-users.svg';
import usersDark from '../assets/images/sidebar/dark-users.svg';
import users from '../assets/images/sidebar/users.svg';
import issuesActive from '../assets/images/sidebar/active-issues.svg';
import issuesDark from '../assets/images/sidebar/dark-issues.svg';
import issues from '../assets/images/sidebar/issues.svg';
import affirmationActive from '../assets/images/sidebar/active-affirmation.svg';
import affirmationDark from '../assets/images/sidebar/dark-affirmation.svg';
import affirmation from '../assets/images/sidebar/affirmation.svg';
import meditationActive from '../assets/images/sidebar/active-meditation.svg';
import meditationDark from '../assets/images/sidebar/dark-meditation.svg';
import meditation from '../assets/images/sidebar/meditation.svg';
//guidance

import focusActive from '../assets/images/sidebar/active-focus.svg';
import focusDark from '../assets/images/sidebar/dark-focus.svg';
import focus from '../assets/images/sidebar/focus.svg';
import ideaActive from '../assets/images/sidebar/active-idea.svg';
import ideaDark from '../assets/images/sidebar/dark-idea.svg';
import idea from '../assets/images/sidebar/idea.svg';
import sleepActive from '../assets/images/sidebar/active-sleep.svg';
import sleepDark from '../assets/images/sidebar/dark-sleep.svg';
import sleep from '../assets/images/sidebar/sleep.svg';
import ritualActive from '../assets/images/sidebar/active-ritual.svg';
import ritualDark from '../assets/images/sidebar/dark-ritual.svg';
import ritual from '../assets/images/sidebar/ritual.svg';
import breathActive from '../assets/images/sidebar/active-breath.svg';
import breathDark from '../assets/images/sidebar/dark-breath.svg';
import breath from '../assets/images/sidebar/breath.svg';
import guidanceActive from '../assets/images/sidebar/active-guidance.svg';
import guidanceDark from '../assets/images/sidebar/dark-guidance.svg';
import guidance from '../assets/images/sidebar/guidance.svg';
import shoorahPods from '../assets/images/sidebar/shoorah-pods.svg';
import activeShoorahPods from '../assets/images/sidebar/active-shoorah-pods.svg';
import activeShoorDark from '../assets/images/sidebar/dark-shoorah-pods.svg';
import earning from '../assets/images/sidebar/earning.svg';
import activeEarning from '../assets/images/sidebar/active-earning.svg';
import earningDark from '../assets/images/sidebar/dark-earning.svg';
import activeDash from '../assets/images/sidebar/active-dashboard.svg';
import activePeapDash from '../assets/images/sidebar/active-peapdashboard.svg';
import activeB2bWellpoints from '../assets/images/sidebar/active-b2bwellpoints.svg';
import activeSpecialistManager from '../assets/images/sidebar/active-specilistmanagement.svg';
import activeDashDark from '../assets/images/sidebar/dark-dashboard.svg';
import feed from '../assets/images/sidebar/feed.svg';
import activeFeed from '../assets/images/sidebar/active-feed.svg';
import activeTutorialIcon from '../assets/images/sidebar/active-tutorialsIcon.svg';
import tutorialIcon from '../assets/images/sidebar/tutorialsIcon.svg';
import tutorialDarkIcon from '../assets/images/sidebar/tutorialDark.svg';
import activeFeedDark from '../assets/images/sidebar/dark-feed.svg';
import legal from '../assets/images/sidebar/legal.svg';
import activeLegal from '../assets/images/sidebar/active-legal.svg';
import darkLegal from '../assets/images/sidebar/dark-legal.svg';
import peapDashboardIcon from '../assets/images/sidebar/peap-dashboard-icon.svg';
import darkPeapDashboardIcon from '../assets/images/sidebar/dark-peap-dashboard-icon.svg';
import activePeapDashboardIcon from '../assets/images/sidebar/active-peap-dashboard-icon.svg';
import wellbankIcon from '../assets/images/sidebar/wellbank-icon.svg';
import darkWellbankIcon from '../assets/images/sidebar/dark-wellbank-icon.svg';
import activeWellbankIcon from '../assets/images/sidebar/active-wellbank-icon.svg';
import AdminIcon from '../assets/images/sidebar/sidebar_admin.svg';
import PeopleManagement from '../assets/images/sidebar/sidebar_people_management.svg';
import Features from '../assets/images/sidebar/sidebar_features.svg';
import Experience from '../assets/images/sidebar/sidebar_experience.svg';
import BusinessHub from '../assets/images/sidebar/sidebar_businesshub.svg';
import { LeftSidebarData } from '../utils/pageContent';

function NewSidebar({ slide }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [subsData, setSubsData] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [sidebarData, setSidebarData] = useState([]);
  const [activeIndexAlt, setActiveIndexAlt] = useState(0);
  //   const [openedSubMenuIndex, setOpenedSubMenuIndex] = useState(null);
  const { isDarkModeEnabled, setIsDarkModeEnabled } = useContext(SidebarContext);
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));

  const [openedSubMenus, setOpenedSubMenus] = useState([]);

  const showBenefits = localStorage.getItem("showBenefits")

  useEffect(() => {
    if (userData?.id) {
      if (userData?.userType === 3) {
        setSidebarData([
          {
            name: LeftSidebarData.adminParentMenu.admin,
            href: `/${userData?.slug}/dashboard`,
            dropDownHref: 'isDropDown',
            icon: AdminIcon,
            activeIcon: AdminIcon,
            darkIcon: AdminIcon,
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.adminParentMenu.dashboard,
                href: `/${userData?.slug}/dashboard`,
                icon: dashboardIcon,
                activeIcon: activedashboardIcon,
                darkIcon: activeDashDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.adminParentMenu.contentApproval,
                href: `/${userData?.slug}/content-approval`,
                icon: approval,
                activeIcon: approvalActive,
                darkIcon: approvalDark,
                access: !userData?.userType,
                show: true
              },
              {
                name: LeftSidebarData.adminParentMenu.myCompany,
                href: `/${userData?.slug}/myCompany`,
                icon: bagIcon,
                activeIcon: activebagIcon,
                darkIcon: darkbagIcon,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.adminParentMenu.report,
                href: `/${userData?.slug}/report`,
                icon: reportIcon,
                activeIcon: activereportIcon,
                darkIcon: darkreportIcon,
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.peopleManagementParentMenu.peopleManagement,
            dropDownHref: 'isDropDown',
            icon: PeopleManagement,
            activeIcon: PeopleManagement,
            darkIcon: PeopleManagement,
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.peopleManagementParentMenu.users,
                href: `/${userData?.slug}/users`,
                icon: userIcon,
                activeIcon: activeuserIcon,
                darkIcon: darkuserIcon,
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              },
              {
                name: LeftSidebarData.peopleManagementParentMenu.subAdmins,
                href: `/${userData?.slug}/sub-admins`,
                icon: subadminIcon,
                activeIcon: activesubadminIcon,
                darkIcon: darksubadminIcon,
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              },
              {
                name: LeftSidebarData.peopleManagementParentMenu.teamChallanges,
                href: `/${userData?.slug}/team-challanges`,
                icon: teamChallenges,
                activeIcon: activeTeamChallenges,
                darkIcon: darkTeamChallenges,
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.featuresAndToolsParentMenu.featuresAndTools,
            dropDownHref: 'isDropDown',
            icon: Features,
            activeIcon: Features,
            darkIcon: Features,
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.pulseSurveys,
                href: `/${userData?.slug}/pulse-survey`,
                icon: approvalIcon,
                activeIcon: activeapprovalIcon,
                darkIcon: darkapprovalIcon,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.peapDashboard,
                href: `/${userData?.slug}/peap-dashboard`,
                icon: peapDashboardIcon,
                activeIcon: activePeapDashboardIcon,
                darkIcon: darkPeapDashboardIcon,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.peapWellbank,
                href: `/${userData?.slug}/peap-wellbank`,
                icon: wellbankIcon,
                activeIcon: activeWellbankIcon,
                darkIcon: darkWellbankIcon,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.instantSupportEAP,
                href: `/${userData?.slug}/instant-support`,
                icon: instantSupport,
                activeIcon: instantSupportActive,
                darkIcon: instantSupportDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.badges,
                href: `/${userData?.slug}/badges`,
                icon: crownIcon,
                activeIcon: activeCrownIcon,
                darkIcon: darkCrownIcon,
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.integrations,
                href: `/${userData?.slug}/integrations`,
                icon: contentIcon,
                activeIcon: activecontentIcon,
                darkIcon: darkcontentIcon,
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.solutions,
                href: `/${userData?.slug}/solution`,
                icon: keyIcon,
                activeIcon: activekeyIcon,
                darkIcon: darkkeyIcon,
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.pushNotifications,
                href: `/${userData?.slug}/push-notification`,
                icon: notiIcon,
                activeIcon: activenotiIcon,
                darkIcon: darknotiIcon,
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.shoorahVids,
                href: `/${userData?.slug}/health-videos`,
                icon: guidance,
                activeIcon: guidanceActive,
                darkIcon: guidanceDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.benefits,
                href: `/${userData?.slug}/benefits`,
                icon: guidance,
                activeIcon: guidanceActive,
                darkIcon: guidanceDark,
                access: true,
                show: JSON.parse(localStorage.getItem('showBenefits'))
              }
            ]
          }
        ]);
      } else if (userData?.userType === 4) {
        setSidebarData([
          {
            name: LeftSidebarData.adminParentMenu.admin,
            href: `/${userData?.slug}/dashboard`,
            dropDownHref: 'isDropDown',
            icon: AdminIcon,
            activeIcon: AdminIcon,
            darkIcon: AdminIcon,
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.adminParentMenu.dashboard,
                href: `/${userData?.slug}/dashboard`,
                icon: dashboardIcon,
                activeIcon: activedashboardIcon,
                darkIcon: activeDashDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.adminParentMenu.myCompany,
                href: `/${userData?.slug}/myCompany`,
                icon: bagIcon,
                activeIcon: activebagIcon,
                darkIcon: darkbagIcon,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.adminParentMenu.report,
                href: `/${userData?.slug}/report`,
                icon: reportIcon,
                activeIcon: activereportIcon,
                darkIcon: darkreportIcon,
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.peopleManagementParentMenu.peopleManagement,
            dropDownHref: 'isDropDown',
            icon: PeopleManagement,
            activeIcon: PeopleManagement,
            darkIcon: PeopleManagement,
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.peopleManagementParentMenu.users,
                href: `/${userData?.slug}/users`,
                icon: userIcon,
                activeIcon: activeuserIcon,
                darkIcon: darkuserIcon,
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              },
              {
                name: LeftSidebarData.peopleManagementParentMenu.teamChallanges,
                href: `/${userData?.slug}/team-challanges`,
                icon: teamChallenges,
                activeIcon: activeTeamChallenges,
                darkIcon: darkTeamChallenges,
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.featuresAndToolsParentMenu.featuresAndTools,
            dropDownHref: 'isDropDown',
            icon: Features,
            activeIcon: Features,
            darkIcon: Features,
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.pulseSurveys,
                href: `/${userData?.slug}/pulse-survey`,
                icon: approvalIcon,
                activeIcon: activeapprovalIcon,
                darkIcon: darkapprovalIcon,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.badges,
                href: `/${userData?.slug}/badges`,
                icon: crownIcon,
                activeIcon: activeCrownIcon,
                darkIcon: darkCrownIcon,
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.integrations,
                href: `/${userData?.slug}/integrations`,
                icon: contentIcon,
                activeIcon: activecontentIcon,
                darkIcon: darkcontentIcon,
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.solutions,
                href: `/${userData?.slug}/solution`,
                icon: keyIcon,
                activeIcon: activekeyIcon,
                darkIcon: darkkeyIcon,
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.notifications,
                href: `/${userData?.slug}/push-notification`,
                icon: notiIcon,
                activeIcon: activenotiIcon,
                darkIcon: darknotiIcon,
                access: true,
                remove: subsData?.account !== 'Expired' ? false : true,
                show: true
              }
              // {
              //   name: LeftSidebarData.featuresAndToolsParentMenu.healthVideos,
              //   href: '/health-videos',
              //   icon: guidance,
              //   activeIcon: guidanceActive,
              //   darkIcon: guidanceDark,
              //   access: true,
              //   show: true
              // }
            ]
          }
        ]);
      } else if (userData?.userType === 5) {
        setSidebarData([
          {
            name: LeftSidebarData.adminParentMenu.admin,
            href: `/${userData?.slug}/dashboard`,
            dropDownHref: 'isDropDown',
            icon: AdminIcon,
            activeIcon: AdminIcon,
            darkIcon: AdminIcon,
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.adminParentMenu.dashboard,
                href: `/partner-dashboard`,
                icon: companyDashboardIcon,
                activeIcon: activedashboardIcon,
                darkIcon: activeDashDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.earnings,
                href: `/partner-earning`,
                icon: earningIcon,
                activeIcon: activeearningIcon,
                darkIcon: darkearningIcon,
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.peopleManagementParentMenu.peopleManagement,
            dropDownHref: 'isDropDown',
            icon: PeopleManagement,
            activeIcon: PeopleManagement,
            darkIcon: PeopleManagement,
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.peopleManagementParentMenu.myAccount,
                href: `/partner-account`,
                icon: userIcon,
                activeIcon: activeuserIcon,
                darkIcon: darkuserIcon,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.peopleManagementParentMenu.introduceCompanies,
                href: `/introduce`,
                icon: contentIcon,
                activeIcon: activecontentIcon,
                darkIcon: darkcontentIcon,
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.featuresAndToolsParentMenu.featuresAndTools,
            dropDownHref: 'isDropDown',
            icon: Features,
            activeIcon: Features,
            darkIcon: Features,
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.notifications,
                href: `/partner-notification`,
                icon: notiIcon,
                activeIcon: activenotiIcon,
                darkIcon: darknotiIcon,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.legals,
                href: `/partner-legals`,
                icon: legal,
                activeIcon: activeLegal,
                darkIcon: darkLegal,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.assets,
                href: `/partner-assets`,
                icon: cmsIcon,
                activeIcon: activecmsIcon,
                darkIcon: darkcmsIcon,
                access: true,
                show: true
              }
              // {
              //   name: LeftSidebarData.featuresAndToolsParentMenu.healthVideos,
              //   href: '/health-videos',
              //   icon: guidance,
              //   activeIcon: guidanceActive,
              //   darkIcon: guidanceDark,
              //   access: true,
              //   show: true
              // }
            ]
          }
        ]);
      } else if (userData?.userType === 6) {
        setSidebarData([
          {
            name: LeftSidebarData.adminParentMenu.dashboard,
            href: `/  -dashboard`,
            icon: companyDashboardIcon,
            activeIcon: activedashboardIcon,
            darkIcon: activeDashDark,
            access: true,
            isDisabled: userData?.expertApprove === 'false'
          },
          {
            name: LeftSidebarData.schedule,
            href: `/#`,
            icon: userIcon,
            activeIcon: activeuserIcon,
            darkIcon: darkuserIcon,
            access: true,
            isDisabled: userData?.expertApprove === 'false'
          },
          {
            name: LeftSidebarData.clients,
            href: `/expert-clients/my-client`,
            icon: earningIcon,
            activeIcon: activeearningIcon,
            darkIcon: darkearningIcon,
            access: true,
            isDisabled: userData?.expertApprove === 'false'
          },
          {
            name: LeftSidebarData.featuresAndToolsParentMenu.notifications,
            href: `/#`,
            icon: notiIcon,
            activeIcon: activenotiIcon,
            darkIcon: darknotiIcon,
            access: true,
            isDisabled: userData?.expertApprove === 'false'
          },
          {
            name: LeftSidebarData.me,
            href: `/expert-me`,
            icon: cmsIcon,
            activeIcon: activecmsIcon,
            darkIcon: darkcmsIcon,
            access: true
          },
          {
            name: LeftSidebarData.payments,
            href: `/#`,
            icon: cmsIcon,
            activeIcon: activecmsIcon,
            darkIcon: darkcmsIcon,
            access: true,
            isDisabled: userData?.expertApprove === 'false'
          }
        ]);
      } else if (userData?.userType === 1) {
        setSidebarData([
          {
            name: LeftSidebarData.adminParentMenu.admin,
            href: '/dashboard',
            dropDownHref: 'isDropDown',
            icon: AdminIcon,
            activeIcon: AdminIcon,
            darkIcon: AdminIcon,
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.adminParentMenu.dashboard,
                href: '/dashboard',
                icon: dashboardIcon,
                activeIcon: activedashboardIcon,
                darkIcon: activeDashDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.adminParentMenu.cms,
                href: '/cms',
                icon: cms,
                activeIcon: cmsActive,
                darkIcon: cmsDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.adminParentMenu.config,
                href: '/config',
                icon: config,
                activeIcon: configActive,
                darkIcon: configDark,
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.peopleManagementParentMenu.peopleManagement,
            dropDownHref: 'isDropDown',
            icon: PeopleManagement,
            activeIcon: PeopleManagement,
            darkIcon: PeopleManagement,
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.peopleManagementParentMenu.users,
                href: '/users',
                icon: userIcon,
                activeIcon: activeuserIcon,
                darkIcon: darkuserIcon,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.peopleManagementParentMenu.ourExperts,
                href: `/podExperts`,
                icon: expertIcon,
                activeIcon: activeExpertIcon,
                darkIcon: expertDark,
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.featuresAndToolsParentMenu.featuresAndTools,
            dropDownHref: 'isDropDown',
            icon: Features,
            activeIcon: Features,
            darkIcon: Features,
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.peapDashboard,
                href: '/peap-dashboard',
                icon: PeapDashboard,
                activeIcon: activepeapdashboardIcon,
                darkIcon: activePeapDash,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.b2bWellPoints,
                href: '/peap-B2B-wellPoints',
                icon: B2BWellPoints,
                activeIcon: activeb2bwellpointsIcon,
                darkIcon: activeB2bWellpoints,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.specialistManager,
                href: '/peap-management',
                icon: SpecialistManagement,
                activeIcon: activespecialistmanagerIcon,
                darkIcon: activeSpecialistManager,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.pulseSurvey,
                href: `/pulse-survey`,
                icon: approvalIcon,
                activeIcon: activeapprovalIcon,
                darkIcon: darkapprovalIcon,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.tutorials,
                href: '/tutorials',
                icon: tutorialIcon,
                activeIcon: activeTutorialIcon,
                darkIcon: tutorialDarkIcon,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.pushNotifications,
                href: '/push-notification',
                icon: pushNotification,
                activeIcon: pushNotificationActive,
                darkIcon: pushNotificationDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.earnings,
                href: '/earning',
                icon: earningIcon,
                activeIcon: activeearningIcon,
                darkIcon: darkearningIcon,
                access: userData?.moduleAccess?.earning_module_access,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.appIssues,
                href: '/app-issues',
                icon: issues,
                activeIcon: issuesActive,
                darkIcon: issuesDark,
                access: !userData?.userType,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.appFeedback,
                href: '/app-feedbacks',
                icon: feed,
                activeIcon: activeFeed,
                darkIcon: activeFeedDark,
                access: true,
                show: true
              }
              // {
              //   name: LeftSidebarData.featuresAndToolsParentMenu.healthVideos,
              //   href: '/health-videos',
              //   icon: guidance,
              //   activeIcon: guidanceActive,
              //   darkIcon: guidanceDark,
              //   access: true,
              //   show: true
              // }
            ]
          },
          {
            name: LeftSidebarData.experienceParentMenu.experience,
            dropDownHref: 'isDropDown',
            icon: Experience,
            activeIcon: Experience,
            darkIcon: Experience,
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.experienceParentMenu.focuses,
                href: '/content-management/focus',
                icon: focus,
                activeIcon: focusActive,
                darkIcon: focusDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.focus,
                href: '/content-management/focus/add-edit',
                icon: approvalIcon,
                activeIcon: activeapprovalIcon,
                darkIcon: activeapprovalIcon,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.focus,
                href: '/content-management/focus/view',
                icon: approvalIcon,
                activeIcon: activeapprovalIcon,
                darkIcon: activeapprovalIcon,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.affirmation,
                href: '/content-management/affirmation',
                icon: affirmation,
                activeIcon: affirmationActive,
                darkIcon: affirmationDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.affirmation,
                href: '/content-management/affirmation/add-edit',
                icon: affirmation,
                activeIcon: affirmationActive,
                darkIcon: affirmationDark,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.affirmation,
                href: '/content-management/affirmation/view',
                icon: affirmation,
                activeIcon: affirmationActive,
                darkIcon: affirmationDark,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.meditation,
                href: '/content-management/meditation',
                icon: meditation,
                activeIcon: meditationActive,
                darkIcon: meditationDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.meditation,
                href: '/content-management/meditation/add-edit',
                icon: meditation,
                activeIcon: meditationActive,
                darkIcon: meditationDark,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.sleepSounds,
                href: '/content-management/sounds',
                icon: sleep,
                activeIcon: sleepActive,
                darkIcon: sleepDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.sleepSounds,
                href: '/content-management/sounds/add-edit',
                icon: sleep,
                activeIcon: sleepActive,
                darkIcon: sleepDark,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.shoorahPods,
                href: '/content-management/shoorah-pods',
                icon: shoorahPods,
                activeIcon: activeShoorahPods,
                darkIcon: activeShoorDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.shoorahPods,
                href: '/content-management/shoorah-pods/add-edit',
                icon: shoorahPods,
                activeIcon: activeShoorahPods,
                darkIcon: activeShoorDark,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.rituals,
                href: '/content-management/rituals',
                icon: ritual,
                activeIcon: ritualActive,
                darkIcon: ritualDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.rituals,
                href: '/content-management/rituals/add-edit',
                icon: ritual,
                activeIcon: ritualActive,
                darkIcon: ritualDark,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.topPicks,
                href: '/content-management/top-picks',
                icon: approvalIcon,
                activeIcon: activeapprovalIcon,
                darkIcon: activeapprovalIcon,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.topPicks,
                href: '/content-management/top-picks/add-edit',
                icon: approvalIcon,
                activeIcon: activeapprovalIcon,
                darkIcon: activeapprovalIcon,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.visionBoardIdeas,
                href: '/content-management/vision-ideas',
                icon: idea,
                activeIcon: ideaActive,
                darkIcon: ideaDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.visionBoardIdeas,
                href: '/content-management/vision-ideas/add-edit',
                icon: idea,
                activeIcon: ideaActive,
                darkIcon: ideaDark,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.breathWork,
                href: '/content-management/breathwork',
                icon: breath,
                activeIcon: breathActive,
                darkIcon: breathDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.shoorahVids,
                href: '/content-management/health',
                icon: guidance,
                activeIcon: guidanceActive,
                darkIcon: guidanceDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.selfAssessment,
                href: `/self-assessment`,
                icon: selfAssessment,
                activeIcon: selfAssessmentActive,
                darkIcon: selfAssessmentDark,
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.businessHubParentMenu.businessHub,
            dropDownHref: 'isDropDown',
            icon: BusinessHub,
            activeIcon: BusinessHub,
            darkIcon: BusinessHub,
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.businessHubParentMenu.b2b,
                href: '/B2B-dashboard',
                icon: dashboardIcon,
                activeIcon: activedashboardIcon,
                darkIcon: activeDash,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.businessHubParentMenu.b2bCompanyList,
                href: '/B2B-company-list',
                icon: company,
                activeIcon: companyActive,
                darkIcon: companyDark,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.businessHubParentMenu.b2bEarnings,
                href: '/B2B-earning',
                icon: earning,
                activeIcon: activeEarning,
                darkIcon: earningDark,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.businessHubParentMenu.partners,
                href: '/partners',
                icon: company,
                activeIcon: companyActive,
                darkIcon: companyDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.businessHubParentMenu.partnerIntroduced,
                href: '/partner-introduced',
                icon: users,
                activeIcon: usersActive,
                darkIcon: usersDark,
                access: true,
                show: false
              }
            ]
          }
        ]);
      } else {
        // Shoorah super Admin
        setSidebarData([
          {
            name: LeftSidebarData.adminParentMenu.admin,
            dropDownHref: 'isDropDown',
            icon: AdminIcon,
            activeIcon: AdminIcon,
            darkIcon: AdminIcon,
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.adminParentMenu.dashboard,
                href: '/dashboard',
                icon: dashboardIcon,
                activeIcon: activedashboardIcon,
                darkIcon: activeDashDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.adminParentMenu.contentApproval,
                href: '/content-approval',
                icon: approval,
                activeIcon: approvalActive,
                darkIcon: approvalDark,
                access: !userData?.userType,
                show: true
              },
              {
                name: LeftSidebarData.adminParentMenu.cms,
                href: '/cms',
                icon: cms,
                activeIcon: cmsActive,
                darkIcon: cmsDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.adminParentMenu.config,
                href: '/config',
                icon: config,
                activeIcon: configActive,
                darkIcon: configDark,
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.peopleManagementParentMenu.peopleManagement,
            dropDownHref: 'isDropDown',
            icon: PeopleManagement,
            activeIcon: PeopleManagement,
            darkIcon: PeopleManagement,
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.peopleManagementParentMenu.users,
                href: '/users',
                icon: userIcon,
                activeIcon: activeuserIcon,
                darkIcon: darkuserIcon,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.peopleManagementParentMenu.ourExperts,
                href: `/podExperts`,
                icon: expertIcon,
                activeIcon: activeExpertIcon,
                darkIcon: expertDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.peopleManagementParentMenu.adminShoorahStaff,
                href: '/sub-admins',
                icon: admin,
                activeIcon: adminActive,
                darkIcon: adminDark,
                access: !userData?.userType,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.featuresAndToolsParentMenu.featuresAndTools,
            dropDownHref: 'isDropDown',
            icon: Features,
            activeIcon: Features,
            darkIcon: Features,
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.pulseSurvey,
                href: `/pulse-survey`,
                icon: approvalIcon,
                activeIcon: activeapprovalIcon,
                darkIcon: darkapprovalIcon,
                access: true,
                show: true
              },
              {
                name: "Peap Management",
                href: '/peap-dashboard',
                icon: PeapDashboard,
                activeIcon: activepeapdashboardIcon,
                darkIcon: activePeapDash,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.b2bWellPoints,
                href: '/peap-B2B-wellPoints',
                icon: B2BWellPoints,
                activeIcon: activeb2bwellpointsIcon,
                darkIcon: activeB2bWellpoints,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.specialistManager,
                href: '/peap-management',
                icon: SpecialistManagement,
                activeIcon: activespecialistmanagerIcon,
                darkIcon: activeSpecialistManager,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.instantSupport,
                href: '/instant-support/b2b',
                icon: instantSupport,
                activeIcon: instantSupportActive,
                darkIcon: instantSupportDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.instantSupportForB2CUsers,
                href: '/instant-support/b2c',
                icon: instantSupport,
                activeIcon: instantSupportActive,
                darkIcon: instantSupportDark,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.shoorahTest,
                href: '/test/tests-dashboard',
                icon: TestIcon,
                activeIcon: activeTestIcon,
                darkIcon: darkTestIcon,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.shoorahTestForB2CUsers,
                href: '/test/b2c',
                icon: TestIcon,
                activeIcon: activeTestIcon,
                darkIcon: darkTestIcon,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.shoorahTestForB2BUsers,
                href: '/test/b2b',
                icon: TestIcon,
                activeIcon: activeTestIcon,
                darkIcon: darkTestIcon,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.tutorials,
                href: '/tutorials',
                icon: tutorialIcon,
                activeIcon: activeTutorialIcon,
                darkIcon: tutorialDarkIcon,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.pushNotifications,
                href: '/push-notification',
                icon: pushNotification,
                activeIcon: pushNotificationActive,
                darkIcon: pushNotificationDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.earnings,
                href: '/earning',
                icon: earningIcon,
                activeIcon: activeearningIcon,
                darkIcon: darkearningIcon,
                access: userData?.moduleAccess?.earning_module_access
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.appIssues,
                href: '/app-issues',
                icon: issues,
                activeIcon: issuesActive,
                darkIcon: issuesDark,
                access: !userData?.userType,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.appFeedback,
                href: '/app-feedbacks',
                icon: feed,
                activeIcon: activeFeed,
                darkIcon: activeFeedDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.featuresAndToolsParentMenu.benefits,
                href: `/benefits`,
                icon: guidance,
                activeIcon: guidanceActive,
                darkIcon: guidanceDark,
                access: true,
                show: true
              },
              // {
              //   name: LeftSidebarData.featuresAndToolsParentMenu.healthVideos,
              //   href: '/health-videos',
              //   icon: guidance,
              //   activeIcon: guidanceActive,
              //   darkIcon: guidanceDark,
              //   access: true,
              //   show: true
              // }
            ]
          },
          {
            name: LeftSidebarData.experienceParentMenu.experience,
            dropDownHref: 'isDropDown',
            icon: Experience,
            activeIcon: Experience,
            darkIcon: Experience,
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.experienceParentMenu.focuses,
                href: '/content-management/focus',
                icon: focus,
                activeIcon: focusActive,
                darkIcon: focusDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.focus,
                href: '/content-management/focus/add-edit',
                icon: approvalIcon,
                activeIcon: activeapprovalIcon,
                darkIcon: activeapprovalIcon,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.focus,
                href: '/content-management/focus/view',
                icon: approvalIcon,
                activeIcon: activeapprovalIcon,
                darkIcon: activeapprovalIcon,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.affirmation,
                href: '/content-management/affirmation',
                icon: affirmation,
                activeIcon: affirmationActive,
                darkIcon: affirmationDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.affirmation,
                href: '/content-management/affirmation/add-edit',
                icon: affirmation,
                activeIcon: affirmationActive,
                darkIcon: affirmationDark,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.affirmation,
                href: '/content-management/affirmation/view',
                icon: affirmation,
                activeIcon: affirmationActive,
                darkIcon: affirmationDark,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.meditation,
                href: '/content-management/meditation',
                icon: meditation,
                activeIcon: meditationActive,
                darkIcon: meditationDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.meditation,
                href: '/content-management/meditation/add-edit',
                icon: meditation,
                activeIcon: meditationActive,
                darkIcon: meditationDark,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.sleepSounds,
                href: '/content-management/sounds',
                icon: sleep,
                activeIcon: sleepActive,
                darkIcon: sleepDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.sleepSounds,
                href: '/content-management/sounds/add-edit',
                icon: sleep,
                activeIcon: sleepActive,
                darkIcon: sleepDark,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.shoorahPods,
                href: '/content-management/shoorah-pods',
                icon: shoorahPods,
                activeIcon: activeShoorahPods,
                darkIcon: activeShoorDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.shoorahPods,
                href: '/content-management/shoorah-pods/add-edit',
                icon: shoorahPods,
                activeIcon: activeShoorahPods,
                darkIcon: activeShoorDark,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.rituals,
                href: '/content-management/rituals',
                icon: ritual,
                activeIcon: ritualActive,
                darkIcon: ritualDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.rituals,
                href: '/content-management/rituals/add-edit',
                icon: ritual,
                activeIcon: ritualActive,
                darkIcon: ritualDark,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.topPicks,
                href: '/content-management/top-picks',
                icon: approvalIcon,
                activeIcon: activeapprovalIcon,
                darkIcon: activeapprovalIcon,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.topPicks,
                href: '/content-management/top-picks/add-edit',
                icon: approvalIcon,
                activeIcon: activeapprovalIcon,
                darkIcon: activeapprovalIcon,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.visionBoardIdeas,
                href: '/content-management/vision-ideas',
                icon: idea,
                activeIcon: ideaActive,
                darkIcon: ideaDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.visionBoardIdeas,
                href: '/content-management/vision-ideas/add-edit',
                icon: idea,
                activeIcon: ideaActive,
                darkIcon: ideaDark,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.experienceParentMenu.breathWork,
                href: '/content-management/breathwork',
                icon: breath,
                activeIcon: breathActive,
                darkIcon: breathDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.shoorahVids,
                href: '/content-management/health',
                icon: guidance,
                activeIcon: guidanceActive,
                darkIcon: guidanceDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.marketplace,
                href: `/marketplace`,
                icon: marketplaceIcon,
                activeIcon: marketplaceIconActive,
                darkIcon: marketplaceIconDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.experienceParentMenu.selfAssessment,
                href: `/self-assessment`,
                icon: selfAssessment,
                activeIcon: selfAssessmentActive,
                darkIcon: selfAssessmentDark,
                access: true,
                show: true
              }
            ]
          },
          {
            name: LeftSidebarData.businessHubParentMenu.businessHub,
            dropDownHref: 'isDropDown',
            icon: BusinessHub,
            activeIcon: BusinessHub,
            darkIcon: BusinessHub,
            access: true,
            isDropDown: true,
            subMenu: [
              {
                name: LeftSidebarData.businessHubParentMenu.b2b,
                href: '/B2B-dashboard',
                icon: dashboardIcon,
                activeIcon: activedashboardIcon,
                darkIcon: activeDash,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.businessHubParentMenu.b2bCompanyList,
                href: '/B2B-company-list',
                icon: company,
                activeIcon: companyActive,
                darkIcon: companyDark,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.businessHubParentMenu.b2bEarnings,
                href: '/B2B-earning',
                icon: earning,
                activeIcon: activeEarning,
                darkIcon: earningDark,
                access: true,
                show: false
              },
              {
                name: LeftSidebarData.businessHubParentMenu.partners,
                href: '/partners',
                icon: company,
                activeIcon: companyActive,
                darkIcon: companyDark,
                access: true,
                show: true
              },
              {
                name: LeftSidebarData.businessHubParentMenu.partnerIntroduced,
                href: '/partner-introduced',
                icon: users,
                activeIcon: usersActive,
                darkIcon: usersDark,
                access: true,
                show: false
              }
            ]
          }
        ]);
      }
    }
  }, [
    subsData,
    setSubsData,
    userData?.expertApprove,
    userData?.id,
    userData?.moduleAccess?.earning_module_access,
    userData?.slug,
    userData?.userType,
    showBenefits
  ]);

  useEffect(() => {
    if (sidebarData.length) {
      let index = sidebarData.findIndex((data) => {
        if (data.isDropDown && data.subMenu) {
          return data.subMenu.some((subItem) => location?.pathname?.includes(subItem.href));
        }
        return location?.pathname?.includes(data.href);
      });

      if (index !== -1) {
        for (let i = 0; i <= index; i++) {
          if (!sidebarData[i].access) {
            index--;
          }
        }
      }

      if (index === -1) {
        setActiveIndexAlt(null);
        setActiveIndex(null);
      } else {
        let adjustedIndex = index;

        openedSubMenus.forEach((submenuIndex) => {
          if (submenuIndex < index) {
            const visibleSubMenus = sidebarData[submenuIndex]?.subMenu?.filter(
              (subItem) => subItem.show
            );
            if (visibleSubMenus?.length) {
              adjustedIndex += visibleSubMenus.length + visibleSubMenus.length * 0.12;
            }
          }
        });

        setActiveIndexAlt(adjustedIndex);
      }
    }
  }, [location.pathname, sidebarData, openedSubMenus]);

  //   useEffect(() => {
  //     if (sidebarData.length) {
  //       let index = sidebarData.findIndex((data) => {
  //         if (data.isDropDown && data.subMenu) {
  //           return data.subMenu.some((subItem) => location?.pathname?.includes(subItem.href));
  //         }
  //         return location?.pathname?.includes(data.href);
  //       });
  //       if (index !== -1) {
  //         for (let i = 0; i <= index; i++) {
  //           if (sidebarData[i].access) {
  //             // index--;
  //           } else {
  //             index--;
  //           }
  //         }
  //       }
  //       if (index === -1) {
  //         setActiveIndexAlt(null);
  //         setActiveIndex(null);
  //       } else {
  //         let adjustedIndex = index;
  //         if (openedSubMenuIndex !== null && openedSubMenuIndex < index) {
  //           const visibleSubMenus = sidebarData[openedSubMenuIndex]?.subMenu.filter(
  //             (subItem) => subItem.show
  //           );
  //           adjustedIndex += visibleSubMenus.length + visibleSubMenus.length * 0.12;
  //         }
  //         setActiveIndexAlt(adjustedIndex);
  //       }
  //     }
  //   }, [location.pathname, sidebarData, openedSubMenuIndex]);

  const getCompanyPlanData = useCallback(() => {
    CompanyApi.getCompanyStatus(userData.companyId)
      .then((res) => {
        if (res?.data?.meta.code === 1) {
          setSubsData(res?.data?.data);
        } else {
          return errorToast(LeftSidebarData.errorToastMessage);
        }
      })
      .catch((err) => {
        return errorToast(err);
      });
  }, [userData?.companyId]);

  useEffect(() => {
    if (userData?.userType === 3 || userData?.userType === 4) {
      getCompanyPlanData();
    }
  }, [getCompanyPlanData, userData?.userType]);

  const handleLogout = async () => {
    if (getDeviceToken()) await Api.logoutUser();
    cleanLocalStorage();
    navigate('/login');
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }

  return (
    <div
      style={{ transition: 'width 0.3s ease-in-out' }}
      className={`flex h-full bg-white dark:bg-shoorah-darkBgTabColor lg:relative fixed lg:top-0 top-[89px] z-40 lg:border-[1.5px] dark:border-none border-r border-shoorah-borderGray flex-col lg:w-[250px] ${
        slide
          ? 'w-[300px] lg:h-full md:h-[calc(100vh-88.8px)] sm:h-[calc(100vh-88.8px)] h-[calc(100vh-88.8px)]'
          : 'w-[0px] h-full'
      }`}
    >
      <div className="h-[100vh] sidebar-container flex-column justify-content-between">
        <div className="lg:flex h-[15vh] lg:h-[14vh] [@media(width:1024px)]:h-[18vh] flex-col hidden justify-center w-full bg-white dark:bg-shoorah-darkBgTabColor items-center px-2 pt-6 pb-6">
          <img className="h-[29px] w-auto dark:invert" src={SidebarLogo} alt="Your Company" />
          <div className="h-[1.5px] w-[calc(100%-48px)] lg:block hidden m-4 bg-shoorah-borderGray2"></div>
        </div>
        <nav className="h-[85vh] md:h-[85vh] [@media(width:1024px)]:h-[55vh] sm:h-[85vh] lg:h-[62vh] overflow-y-auto sidebar-container hide-scroll">
          {sidebarData?.map((item, index) =>
            !item?.access ? (
              ''
            ) : (
              <Menu
                key={index}
                item={item}
                index={index}
                slide={slide}
                setActiveIndex={setActiveIndex}
                // openedSubMenuIndex={openedSubMenuIndex}
                // setOpenedSubMenuIndex={setOpenedSubMenuIndex}
                openedSubMenus={openedSubMenus}
                setOpenedSubMenus={setOpenedSubMenus}
              />
            )
          )}
        </nav>
        <div className="lg:flex h-[18vh] lg:h-[18vh] [@media(width:1024px)]:h-[20vh] justify-center w-full  z-50  dark:bg-shoorah-darkBgTabColor items-center px-2 pt-6 pb-[10px]">
          <div className="lg:flex hidden flex-col justify-center items-center flex-shrink-0 w-full">
            <div className="group flex-shrink-0 h-[1.5px] w-[calc(100%-48px)] lg:block hidden mx-6 mb-2 mt-2 bg-shoorah-borderGray2"></div>
            <div className="group block w-full flex-shrink-0 cursor-pointer py-[18px] ps-[18px]">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <img
                    src={darkMoonIcon}
                    alt="sidebar_icon"
                    className={`mr-3 ml-2 h-6 w-6 flex-shrink-0 dark:block hidden`}
                  />
                  <img
                    src={moonIcon}
                    alt="sidebar_icon"
                    className={`mr-3 ml-2 h-6 w-6 flex-shrink-0 dark:hidden block`}
                  />
                  <p className="text-sm text-shoorah-lightBlack dark:text-shoorah-darkBg font-medium">
                    {LeftSidebarData.darkMode}
                  </p>
                </div>
                <Switch
                  checked={isDarkModeEnabled}
                  onChange={() => {
                    setIsDarkModeEnabled(!isDarkModeEnabled);
                  }}
                  className={classNames(
                    isDarkModeEnabled ? '' : '',
                    'mr-3 ml-2 relative border-shoorah-lightBlack dark:border-shoorah-darkBg inline-flex h-4 w-7 flex-shrink-0 cursor-pointer rounded-full border-2 duration-200 ease-in-out focus:outline-none'
                  )}
                >
                  <span
                    aria-hidden="true"
                    className={classNames(
                      isDarkModeEnabled ? 'translate-x-3' : 'translate-x-0',
                      'pointer-events-none inline-block h-3 w-3 transform rounded-full bg-shoorah-lightBlack dark:bg-shoorah-darkBg border-shoorah-darkBg shadow ring-0 transition duration-200 ease-in-out'
                    )}
                  />
                </Switch>
              </div>
            </div>
            <div className="group block w-full flex-shrink-0 cursor-pointer py-[18px] ps-[18px]">
              <div
                className="flex items-center"
                onClick={() => {
                  handleLogout();
                }}
              >
                <img
                  src={logOutIcon}
                  alt="sidebar_icon"
                  className={`mr-3 ml-2 h-6 w-6 flex-shrink-0 dark:hidden block`}
                />
                <img
                  src={darkLogOutIcon}
                  alt="sidebar_icon"
                  className={`mr-3 ml-2 h-6 w-6 flex-shrink-0 dark:block hidden`}
                />
                <p className="text-sm text-shoorah-lightBlack dark:text-shoorah-darkBg font-medium">
                  {LeftSidebarData.logOut}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewSidebar;
